// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.relative-container {
    position: relative; /* Anchors the absolute overlay inside this container */
}
  
.spinner-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.7); /* Dims the content underneath */
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10; /* Forces the spinner to sit above the content */
}

.spinner-overlayER {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.7); /* Dims the content underneath */
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10; /* Forces the spinner to sit above the content */
}
  
.spinner {
    width: 40px;
    height: 40px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #3498db;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}
  
@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}`, "",{"version":3,"sources":["webpack://./src/common/spinnerER.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB,EAAE,uDAAuD;AAC/E;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,0CAA0C,EAAE,gCAAgC;IAC5E,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW,EAAE,gDAAgD;AACjE;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,0CAA0C,EAAE,gCAAgC;IAC5E,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW,EAAE,gDAAgD;AACjE;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC","sourcesContent":[".relative-container {\n    position: relative; /* Anchors the absolute overlay inside this container */\n}\n  \n.spinner-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(255, 255, 255, 0.7); /* Dims the content underneath */\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 10; /* Forces the spinner to sit above the content */\n}\n\n.spinner-overlayER {\n    position: relative;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(255, 255, 255, 0.7); /* Dims the content underneath */\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 10; /* Forces the spinner to sit above the content */\n}\n  \n.spinner {\n    width: 40px;\n    height: 40px;\n    border: 4px solid #f3f3f3;\n    border-top: 4px solid #3498db;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n}\n  \n@keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
